import React, { useContext, useEffect } from 'react'
import { IframeLayout } from '../../../components/Layouts'
import { ErrorBoundary } from '@sentry/react'
import { ErrorMsg } from '../../../components/AppMessages'
import { IframePageContent } from '../../../components/PageContent'
import { GlobalMSSalesFilters } from '../../../components/Filters/GlobalMSSalesFilters'
import { GlobalMSSalesGoogleAccessBanner } from '../../../components/Banners/GlobalMSSalesGoogleAccessBanner'
import { GLOBAL_MS_SALES_BTN_FILTERS, LookStudioEmbeddedLinks } from '../../../constants/globalMSSalesConstants'
import { DashboardBannerContext } from '../../../context'

const GlobalMSSalesTierThree = () => {
    const { setBannerText, setShowBanner } = useContext(DashboardBannerContext);

    useEffect(() => {
        setBannerText(<GlobalMSSalesGoogleAccessBanner />);
        setShowBanner(true);
        // DashboardBannerContext lives in App.tsx, above the router - it never unmounts on navigation,
        // so showBanner/bannerText persist across routes unless explicitly reset here (see
        // CcsMonetizationFilters.tsx's own comment on this exact leak).
        return () => {
            setShowBanner(false);
            setBannerText("");
        };
    }, []);

    return (
        <IframeLayout hasFilter={true}>
            <ErrorBoundary fallback={<ErrorMsg />}>
                <IframePageContent
                    frameId="global_ms_sales_tier_three"
                    filter={<GlobalMSSalesFilters filterBtns={GLOBAL_MS_SALES_BTN_FILTERS} />}
                    iframeUrl={LookStudioEmbeddedLinks.tier_three}
                />
            </ErrorBoundary>
        </IframeLayout>
    )
}

export default GlobalMSSalesTierThree;
